$(function() {
  $(window).on('load', () => {
    $('.block-editorial-block a[target="_blank"]:not(:has(img))').addClass('btn btn-primary');
    $('.block-prices-content a').addClass('btn btn-primary');
    $('.is-style-fill .wp-block-button__link').addClass('btn btn-primary').removeClass('wp-block-button__link');
    $('.is-style-outline .wp-block-button__link').addClass('btn btn-outline-primary').removeClass('wp-block-button__link');
  });
});
